// found at: https://stackoverflow.com/a/25346429/1999083
const escape = str => str.replace(/([.*+?\^$(){}|\[\]\/\\])/g, "\\$1"); // eslint-disable-line no-useless-escape
export const getCookie = key => {
  var match = document.cookie.match(
    RegExp("(?:^|;\\s*)" + escape(key) + "=([^;]*)")
  );
  return match ? match[1] : null;
};
